import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Address } from '@checkout/const';
import { DeliveryAddressService } from '@checkout/feature';
import { ModalService } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { SdvorDeliveryAddressListModalComponent } from '../delivery-address-list-modal';

@Component({
  selector: 'sd-delivery-active-address',
  templateUrl: './delivery-active-address.component.html',
  styleUrls: ['./delivery-active-address.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdvorDeliveryActiveAddressComponent implements OnInit {
  activeAddress$: Observable<Address>;

  constructor(
    private modalService: ModalService,
    private deliveryAddressService: DeliveryAddressService,
  ) {}

  ngOnInit(): void {
    this.activeAddress$ = this.deliveryAddressService.activeAddress$;
  }

  openModal(): void {
    this.modalService.open(SdvorDeliveryAddressListModalComponent, { size: 'lg' });
  }
}
